import { toRefs, ref, watch, watchEffect } from 'vue';
import { isClient } from '../../utils/component-lib.esm2.js';

//
const QrDotTypes = ['rounded', 'extra-rounded', 'square', 'dots', 'classy', 'classy-rounded'];
const QrCodeProps = {
  /** Size of canvas */
  height: {
    type: Number,
    default: 1000
  },
  /** Size of canvas */
  width: {
    type: Number,
    default: 1000
  },
  /** The date will be encoded to the QR code */
  data: {
    type: String,
    required: true
  },
  /** The image will be copied to the center of the QR code */
  image: String,
  /** Margin around canvas */
  margin: {
    type: Number,
    default: 0
  },
  imageMargin: {
    type: Number,
    default: 5
  },
  imageCrossOrigin: {
    type: String,
    default: 'anonymous'
  },
  /** Color of QR dots */
  dotsColor: {
    type: String,
    default: '#000'
  },
  /** Style of QR dots */
  dotsType: {
    type: String,
    default: 'rounded'
  },
  /** Background color of the QR code */
  backgroundColor: {
    type: String,
    default: '#fff'
  }
};
var script = {
  props: QrCodeProps,
  setup(props) {
    const {
      height,
      width,
      data,
      dotsColor,
      dotsType,
      margin,
      backgroundColor,
      imageMargin,
      imageCrossOrigin,
      image
    } = toRefs(props);
    const code = ref(null);
    let qrCode;
    function appendCode() {
      qrCode.append(code.value);
    }
    function download() {
      let ext = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'png';
      qrCode.download({
        extension: ext
      });
    }
    if (isClient) {
      const QRCodeStyling = require('qr-code-styling');
      qrCode = new QRCodeStyling();
      watch(code, () => appendCode());
      watchEffect(() => {
        qrCode.update({
          width: height.value,
          height: width.value,
          data: data.value,
          image: image.value,
          margin: margin.value,
          dotsOptions: {
            color: dotsColor.value,
            type: dotsType.value
          },
          imageOptions: {
            crossOrigin: imageCrossOrigin.value,
            margin: imageMargin.value
          },
          backgroundOptions: {
            color: backgroundColor.value
          }
        });
      });
    }
    return {
      code,
      download
    };
  }
};
export { QrCodeProps, QrDotTypes, script as default };